/**
 * ApprovalBanner Component - Shopify Sales Channel Requirement
 *
 * Communicates approval or rejection status for use of the sales channel
 * to merchants using the Polaris Banner component.
 *
 * States:
 * - approved: Store is approved to sell on InClub
 * - rejected: Store was not approved (with reason)
 * - pending: Setup in progress
 * - not_connected: Store needs to connect to InClub
 */

import React from 'react';
import { Banner } from '@shopify/polaris';

export default function ApprovalBanner({ status, rejectionReason }) {
  if (status === 'approved' || status === 'connected') {
    return (
      <Banner title="Sales Channel Active" tone="success">
        <p>Your store is approved to sell on InClub. Publish products to make them available to your community.</p>
      </Banner>
    );
  }

  if (status === 'rejected') {
    return (
      <Banner title="Sales Channel Not Approved" tone="critical">
        <p>Your store has not been approved for the InClub sales channel.</p>
        {rejectionReason && <p>Reason: {rejectionReason}</p>}
        <p>Please contact support at support@inclub.vip for more information.</p>
      </Banner>
    );
  }

  if (status === 'pending') {
    return (
      <Banner title="Setup In Progress" tone="info">
        <p>Complete the connection process to start publishing products to InClub.</p>
      </Banner>
    );
  }

  // not_connected or unknown status
  return (
    <Banner title="Connect to InClub" tone="info">
      <p>Connect your store to InClub to start selling products to your community.</p>
    </Banner>
  );
}
